/* eslint-disable object-shorthand */
import axios from 'axios'

import config from '../../config'
import action, { actionFailed } from '../../util/action'
import createAsyncConst from '../../util/createAsyncConst'

export const FETCH_STOCK_RELATORY_INIT = createAsyncConst(
  'FETCH_STOCK_RELATORY_INIT'
)
export const MAKE_STOCK_RELATORY = createAsyncConst('MAKE_STOCK_RELATORY')

export function fetchStockRelatoryInit(type, filters = []) {
  return dispatch => {
    dispatch(action(FETCH_STOCK_RELATORY_INIT.ACTION))
    return axios
      .get(`${config.API_URL}/movement-items/${type}`, {
        params: filters,
      })
      .then(resp => {
        dispatch(
          action(FETCH_STOCK_RELATORY_INIT.SUCCESS, {
            data: resp.data,
            filters: filters,
          })
        )
        return resp
      })
      .catch(e => dispatch(actionFailed(FETCH_STOCK_RELATORY_INIT, e)))
  }
}

export function makeRelatory(data, type) {
  return dispatch => {
    return axios({
      url: `${config.API_URL}/make-relatory-stock/${type}`,
      method: 'POST',
      responseType: 'blob',
      headers: { Accept: 'application/vnd.ms-excel' },
      params: data,
    })
      .then(resp => {
        const url = window.URL.createObjectURL(new Blob([resp.data]))
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', 'stock_relatory.xlsx')
        document.body.appendChild(link)
        link.click()
        return resp
      })
      .catch(e => dispatch(actionFailed(MAKE_STOCK_RELATORY, e)))
  }
}
